import {JsonObject, JsonProperty} from "json2typescript";

import {JsonPropertyEmpty} from "../../utils/json-util";
import {TagOutput} from "./tag-output";

@JsonObject("TagSearchOutput")
export class TagSearchOutput {
    @JsonProperty("tags", [TagOutput])
    public tags: TagOutput[] = JsonPropertyEmpty;
}
